import type { PropType } from 'vue'
import { computed, h, useSlots } from 'vue'

import { colors } from '@/assets/scss/variables'
import { variants } from '@/utils/variants'

import type { VariantPropsOf } from '@/utils/variants'

import s from './style.module.scss'

const styles = variants({
  base: s.root,
  defaultVariants: {
    align: 'left',
    size: 'md',
    type: 'regular',
  },
  variants: {
    align: {
      center: s.center,
      left: s.left,
      right: s.right,
    },
    size: {
      lg: s['size-lg'],
      md: s['size-md'],
      sm: s['size-sm'],
      xl: s['size-xl'],
      xs: s['size-xs'],
    },
    type: {
      black: s.black,
      bold: s.bold,
      extrabold: s.extrabold,
      extralight: s.extralight,
      light: s.light,
      medium: s.medium,
      regular: s.regular,
      semibold: s.semibold,
      thin: s.thin,
    },
  },
})

export type Props = VariantPropsOf<typeof styles> & {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div'
  color?: keyof typeof colors
}

export const T = (props: Props) => {
  const slots = useSlots()
  const color = props.color ? colors[props.color] : undefined
  const classes = computed(() => {
    return styles({
      align: props.align,
      size: props.size,
      type: props.type,
    })
  })
  const as = props.as ?? 'p'

  return h(as, { class: classes.value, style: { color } }, slots.default?.())
}

T.props = {
  align: String as PropType<Props['align']>,
  as: String as PropType<Props['as']>,
  color: String as PropType<Props['color']>,
  size: String as PropType<Props['size']>,
  type: String as PropType<Props['type']>,
}
